export default "__VITE_ASSET__NPJgzhH6__"